import { UploadState } from './types';

export const defaultCsvOfferData = {
  isEligible: false,
  extensionID: 0,
  isGoToCheckout: false,
  isUploadedItemsPreviewEnabled: false,
  isLatestProductCatalogueDownloadEnabled: false,
  shopURL: '',
  theme: {
    titleText: 'Bulk order using CSV',
    subtitleText:
      'Download the product catalog, set the desired quantities and upload the csv back to create your order.',
    uploadPopupTitleText: 'upload popup title',
    uploadPopupDescriptionText: 'upload popup description',
    uploadPopupCancelButtonText: 'Cancel',
    uploadPopupSubmitButtonText: 'Submit',
    uploadButtonText: 'Upload CSV',
    downloadButtonText: 'Download catalog',
    orderSummaryTableTitleText: 'Order summary',
    orderSummaryTableProductText: 'Product',
    orderSummaryTableQuantityText: 'Quantity',
    orderSummaryTableAvailableStockText: 'Available stock',
    orderSummaryTableMinimumQuantityText: 'Minimum Quantity',
    orderSummaryTableVariantSKUText: "Variants SKU's",
    orderSummaryTableShowSummaryText: 'Show summary',
    orderSummaryTableHideSummaryText: 'Hide summary',
    createOrderText: 'Create order',
    downloadCompletedText: 'Download completed',
    fetchingCatalogueText: 'fetching',
    processingText: 'processing',
    errorTitleText: 'error',
    errorInvalidVariantText:
      '{Product_name 1, Product name 2, ...}-{Error_text}',
    errorMinOrderQuantityText:
      '{Product_name 1, Product name 2, ...}-{Error_text}',
    errorMaxOrderQuantityText:
      '{Product_name 1, Product name 2, ...}-{Error_text}',
    errorFileFormatText: 'This error is not applicable on line items ',
    errorIncrementQuantityText: 'There is an error with increment quantity',
    errorAvailableQuantityText: 'Quantity is more than available',
    errorMaxRowsLimitReachedText: 'Max rows limit reached',
    titleFontSize: 'base',
    subtitleFontSize: 'small',
    locationFontSize: 'base',
    fileNameFontSize: 'base',
    uploadButtonFontSize: 'small',
    downloadButtonFontSize: 'small',
    orderSummaryTableTitleFontSize: 'large',
    orderSummaryTableColumnsFontSize: 'base',
    errorTitleFontSize: 'large',
    errorSummaryFontSize: 'base',
    errorLineItemFontSize: 'base',
  },
};

export const getDefaultUploadState = (
  uploadButtonText: string,
): UploadState => ({
  uploadID: 0,
  uploadPageUrl: '',
  uploadCsvButtonText: uploadButtonText,
  uploadModalLoading: false,
  isRequestForUploadStatus: false,
  uploadedDataForTable: [],
  uploadFileName: '',
  uploadError: '',
  fileToUpload: null,
  submitButtonLoading: false,
});

export const columns = [
  {
    identifier: 'variant_id',
    identifierID: '550e8400-e29b-41d4-a716-446655440000',
    columnName: 'Variant ID',
    priority: 2,
    isShowInOrderSummary: true
  },
  {
    identifier: 'quantity',
    identifierID: 'c2f5eb4d-8f75-4203-9533-53e54cb02b94',
    columnName: 'Quantity',
    priority: 0,
    isShowInOrderSummary: true
  },
  {
    identifier: 'product_name',
    identifierID: 'e2735d8e-72b3-4e47-8104-9837a3db81ee',
    columnName: 'Product Name',
    priority: 1,
    isShowInOrderSummary: true
  },
  {
    identifier: 'product_id',
    identifierID: '3d9f1df5-f8c1-49b6-8d49-50820a6c7a1d',
    columnName: 'Product ID',
    priority: 3,
    isShowInOrderSummary: false
  },
  {
    identifier: 'available_stock',
    identifierID: '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1',
    columnName: 'Available Stock',
    priority: 4,
    isShowInOrderSummary: false
  },
  {
    identifier: 'increment',
    identifierID: 'increment',
    columnName: 'increment',
    priority: 5,
    isShowInOrderSummary: true
  },
  {
    identifier: 'maximum_quantity',
    identifierID: 'maximum_quantity',
    columnName: 'maximum_quantity',
    priority: 6,
    isShowInOrderSummary: true
  },
  {
    identifier: 'minimum_quantity',
    identifierID: 'minimum_quantity',
    columnName: 'minimum_quantity',
    priority: 7,
    isShowInOrderSummary: true
  },
  {
    identifier: 'variant_sku',
    identifierID: '00000000-0000-0000-0000-000000000004',
    columnName: 'Variant SKU',
    priority: 8,
    isShowInOrderSummary: false
  },
  {
    identifier: 'barcode',
    identifierID: '00000000-0000-0000-0000-000000000005',
    columnName: 'Barcode',
    priority: 9,
    isShowInOrderSummary: false
  }
];

export const tabledata = [
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'Selling Plans Ski Wax',
    '550e8400-e29b-41d4-a716-446655440000': '46020370727157',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '20',
    'minimum_quantity': '2',
    'maximum_quantity': '100',
    'increment': '2',
    "00000000-0000-0000-0000-000000000004": "",
    "00000000-0000-0000-0000-000000000005": "",
    "Is Error": "true",
    "Error": "errorIncrementQuantityText",
  },
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'Selling Plans Ski Wax',
    '550e8400-e29b-41d4-a716-446655440000': '46020370792693',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '55',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '9',
    'minimum_quantity': '2',
    'maximum_quantity': '100',
    'increment': '2',
    "00000000-0000-0000-0000-000000000004": "",
    "00000000-0000-0000-0000-000000000005": "",
    "Is Error": "true",
    "Error": "errorAvailableQuantityText",
  },
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The 3p Fulfilled Snowboard',
    '550e8400-e29b-41d4-a716-446655440000': '46020371284213',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '55',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '15',
    'minimum_quantity': '3',
    'maximum_quantity': '99',
    'increment': '3',
    "00000000-0000-0000-0000-000000000004": "sku-hosted-1",
    "00000000-0000-0000-0000-000000000005": "stsgsvgd24",
    "Is Error": "true",
    "Error": "errorIncrementQuantityText",
  },
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Collection Snowboard: Hydrogen',
    '550e8400-e29b-41d4-a716-446655440000': '46020370694389',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '34',
    'minimum_quantity': '1',
    'maximum_quantity': '',
    'increment': '1',
    "00000000-0000-0000-0000-000000000004": "",
    "00000000-0000-0000-0000-000000000005": "",
    "Is Error": "false",
    "Error": "",
  },
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Collection Snowboard: Liquid',
    '550e8400-e29b-41d4-a716-446655440000': '46020371316981',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '32',
    'minimum_quantity': '1',
    'maximum_quantity': '',
    'increment': '1',
    "00000000-0000-0000-0000-000000000004": "",
    "00000000-0000-0000-0000-000000000005": "515161651",
    "Is Error": "false",
    "Error": "",
  },
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Collection Snowboard: Oxygen',
    '550e8400-e29b-41d4-a716-446655440000': '46020371185909',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '50',
    'minimum_quantity': '5',
    'maximum_quantity': '100',
    'increment': '5',
    "00000000-0000-0000-0000-000000000004": "sku-hosted-1",
    "00000000-0000-0000-0000-000000000005": "",
    "Is Error": "false",
    "Error": "",
  },
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Compare at Price Snowboard',
    '550e8400-e29b-41d4-a716-446655440000': '46020370628853',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '9',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '5',
    'minimum_quantity': '1',
    'maximum_quantity': '',
    'increment': '1',
    "00000000-0000-0000-0000-000000000004": "",
    "00000000-0000-0000-0000-000000000005": "",
    "Is Error": "true",
    "Error": "errorAvailableQuantityText",
  },
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Complete Snowboard',
    '550e8400-e29b-41d4-a716-446655440000': '46020371022069',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '10',
    'minimum_quantity': '1',
    'maximum_quantity': '',
    'increment': '1',
    "00000000-0000-0000-0000-000000000004": "",
    "00000000-0000-0000-0000-000000000005": "",
    "Is Error": "false",
    "Error": "",
  },
  {
    'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Complete Snowboard',
    '550e8400-e29b-41d4-a716-446655440000': '46020371087605',
    'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
    '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '10',
    'minimum_quantity': '1',
    'maximum_quantity': '',
    'increment': '1',
    "00000000-0000-0000-0000-000000000004": "",
    "00000000-0000-0000-0000-000000000005": "",
    "Is Error": "false",
    "Error": "",
  },

  //------------------------------------------------------------------------------------------------------------ //

  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'Selling Plans Ski Wax',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020370727157',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '20',
  //   '00000000-0000-0000-0000-000000000003': '2',
  //   '00000000-0000-0000-0000-000000000002': '100',
  //   '00000000-0000-0000-0000-000000000001': '2',
  //   "00000000-0000-0000-0000-000000000004": "",
  //   "00000000-0000-0000-0000-000000000005": "",
  //   "Is Error": "true",
  //   "Error": "errorIncrementQuantityText",
  // },
  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'Selling Plans Ski Wax',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020370792693',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '55',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '9',
  //   '00000000-0000-0000-0000-000000000003': '2',
  //   '00000000-0000-0000-0000-000000000002': '100',
  //   '00000000-0000-0000-0000-000000000001': '2',
  //   "00000000-0000-0000-0000-000000000004": "",
  //   "00000000-0000-0000-0000-000000000005": "",
  //   "Is Error": "true",
  //   "Error": "errorAvailableQuantityText",
  // },
  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The 3p Fulfilled Snowboard',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020371284213',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '55',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '15',
  //   '00000000-0000-0000-0000-000000000003': '3',
  //   '00000000-0000-0000-0000-000000000002': '99',
  //   '00000000-0000-0000-0000-000000000001': '3',
  //   "00000000-0000-0000-0000-000000000004": "sku-hosted-1",
  //   "00000000-0000-0000-0000-000000000005": "stsgsvgd24",
  //   "Is Error": "true",
  //   "Error": "errorIncrementQuantityText",
  // },
  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Collection Snowboard: Hydrogen',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020370694389',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '34',
  //   '00000000-0000-0000-0000-000000000003': '1',
  //   '00000000-0000-0000-0000-000000000002': '',
  //   '00000000-0000-0000-0000-000000000001': '1',
  //   "00000000-0000-0000-0000-000000000004": "",
  //   "00000000-0000-0000-0000-000000000005": "",
  //   "Is Error": "false",
  //   "Error": "",
  // },
  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Collection Snowboard: Liquid',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020371316981',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '32',
  //   '00000000-0000-0000-0000-000000000003': '1',
  //   '00000000-0000-0000-0000-000000000002': '',
  //   '00000000-0000-0000-0000-000000000001': '1',
  //   "00000000-0000-0000-0000-000000000004": "",
  //   "00000000-0000-0000-0000-000000000005": "515161651",
  //   "Is Error": "false",
  //   "Error": "",
  // },
  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Collection Snowboard: Oxygen',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020371185909',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '50',
  //   '00000000-0000-0000-0000-000000000003': '5',
  //   '00000000-0000-0000-0000-000000000002': '100',
  //   '00000000-0000-0000-0000-000000000001': '5',
  //   "00000000-0000-0000-0000-000000000004": "sku-hosted-1",
  //   "00000000-0000-0000-0000-000000000005": "",
  //   "Is Error": "false",
  //   "Error": "",
  // },
  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Compare at Price Snowboard',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020370628853',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '9',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '5',
  //   '00000000-0000-0000-0000-000000000003': '1',
  //   '00000000-0000-0000-0000-000000000002': '',
  //   '00000000-0000-0000-0000-000000000001': '1',
  //   "00000000-0000-0000-0000-000000000004": "",
  //   "00000000-0000-0000-0000-000000000005": "",
  //   "Is Error": "true",
  //   "Error": "errorAvailableQuantityText",
  // },
  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Complete Snowboard',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020371022069',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '10',
  //   '00000000-0000-0000-0000-000000000003': '1',
  //   '00000000-0000-0000-0000-000000000002': '',
  //   '00000000-0000-0000-0000-000000000001': '1',
  //   "00000000-0000-0000-0000-000000000004": "",
  //   "00000000-0000-0000-0000-000000000005": "",
  //   "Is Error": "false",
  //   "Error": "",
  // },
  // {
  //   'e2735d8e-72b3-4e47-8104-9837a3db81ee': 'The Complete Snowboard',
  //   '550e8400-e29b-41d4-a716-446655440000': '46020371087605',
  //   'c2f5eb4d-8f75-4203-9533-53e54cb02b94': '5',
  //   '9fd3c276-6e63-4d44-bc39-5f1c9cf8ecb1': '10',
  //   '00000000-0000-0000-0000-000000000003': '1',
  //   '00000000-0000-0000-0000-000000000002': '',
  //   '00000000-0000-0000-0000-000000000001': '1',
  //   "00000000-0000-0000-0000-000000000004": "",
  //   "00000000-0000-0000-0000-000000000005": "",
  //   "Is Error": "false",
  //   "Error": "",
  // },
];